import { render, staticRenderFns } from "./PostCodeArea.vue?vue&type=template&id=4aef4bbe&scoped=true&"
import script from "./PostCodeArea.vue?vue&type=script&lang=js&"
export * from "./PostCodeArea.vue?vue&type=script&lang=js&"
import style0 from "./PostCodeArea.vue?vue&type=style&index=0&id=4aef4bbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aef4bbe",
  null
  
)

export default component.exports